var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar7 = function SvgCalendar7(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.615 11.365v-.65h-5.12v1.02c0 .043.01.087.03.13.02.04.045.077.075.11.033.03.07.055.11.075a.372.372 0 0 0 .135.025h3.205a2.82 2.82 0 0 0-.265.33 4.8 4.8 0 0 0-.23.38L9.955 18h1.13c.213 0 .383-.05.51-.15.13-.1.23-.22.3-.36l2.53-5.36c.04-.08.081-.178.125-.295a1.41 1.41 0 0 0 .065-.47Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 4h1c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5a2 2 0 0 1-2-2l.01-14c0-1.1.88-2 1.99-2h1V2h2v2h8V2h2v2ZM5 20h14V9H5v11Z"
  })));
};
export default SvgCalendar7;